export default function initDisableButtonAttachment() {
    const buttons = document.getElementsByClassName('govuk-button');
    const continueButton = buttons[buttons.length - 1];
    if (!continueButton) {
        return;
    }

    const consentBox = document.getElementsByClassName('govuk-checkboxes__input')[0];
    const radioButtonTailored = document.getElementsByClassName('govuk-radios__input')[0];
    const radioButtonGeneral = document.getElementsByClassName('govuk-radios__input')[1];

    let radioButtonChecked = false;
    let checkboxChecked = false;
    continueButton.disabled = true;

    function EnableDisableContinueButton() {
        if (
            checkboxChecked === true &&
            (radioButtonChecked === true || radioButtonTailored.checked || radioButtonGeneral.checked)
        ) {
            continueButton.disabled = false;
        } else {
            continueButton.disabled = true;
        }
    }

    radioButtonTailored.addEventListener('change', () => {
        if (radioButtonTailored.checked) {
            radioButtonChecked = true;
            EnableDisableContinueButton();
        } else {
            radioButtonChecked = false;
            EnableDisableContinueButton();
        }
    });

    radioButtonGeneral.addEventListener('change', () => {
        if (radioButtonGeneral.checked) {
            radioButtonChecked = true;
            EnableDisableContinueButton();
        } else {
            radioButtonChecked = false;
            EnableDisableContinueButton();
        }
    });

    consentBox.addEventListener('change', () => {
        if (consentBox.checked === true) {
            checkboxChecked = true;
            EnableDisableContinueButton();
        } else {
            checkboxChecked = false;
            EnableDisableContinueButton();
        }
    });
}
